import api from './axios';

interface LoginCredentials {
  username: string;
  password: string;
}

interface LoginResponse {
  message: string;
  user: {
    id: number;
    username: string;
  };
}

interface VerifyResponse {
  message: string;
  user: {
    id: number;
    username: string;
  };
}

/**
 * Login user
 * @param credentials User credentials (username and password)
 * @returns Login response
 */
export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>('/auth/login', credentials, {
    withCredentials: true // Important for cookies
  });
  return response.data;
};

/**
 * Verify authentication status
 * @returns Verification response if authenticated
 */
export const verify = async (): Promise<VerifyResponse> => {
  const response = await api.get<VerifyResponse>('/auth/verify', {
    withCredentials: true
  });
  return response.data;
}; 